import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaOperacion } from '../_operacion.js';

/**
 * La pantalla de conteo del efectivo. Cuelga de `_operacion`, así que el guardián de
 * `jornada.abrirCerrar` ya se aplicó y esta ruta no repite ninguna verificación.
 *
 * El componente llega A PEDIDO y no importado directo, que es lo que pedía el plan: con
 * el import directo, `arbol.ts` arrastra `@tanstack/query`, la pantalla y el cliente de
 * Supabase al fragmento de entrada, que es el que descarga alguien que todavía no inició
 * sesión. Es la adjudicación 41, la misma que ya movió la pantalla de usuarios.
 */
export const rutaConteo = createRoute({
  getParentRoute: () => rutaOperacion,
  path: '/jornada/conteo',
  component: lazyRouteComponent(
    () => import('../../funcionalidades/conteo-efectivo/PaginaConteo.js'), 'PaginaConteo'),
});
